<template>
  <div class="animated revealUp">
    <div class="section-title mb-3">{{ $t("edit") }} {{ $t("invoice") }}</div>
    <section class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 2) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  v-on:click="onSelectCinema(cinema)"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <Tooltip :title="$t('invoice_selectCinema')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedVendor.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("vendor", 1) }}</label
              >
              <b-dropdown
                :text="selectedVendor"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Vendor"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchVendor()"
                    v-on:keydown="onSearchVendor()"
                    v-on:search="onSearchVendor()"
                    v-model="searchVendor"
                  />
                </div>
                <b-dropdown-item
                  v-for="(vendor, vendorKey) in Vendors"
                  :key="vendorKey"
                  v-on:click="onSelectVendor(vendor)"
                  >{{ vendor.v_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
            <Tooltip :title="$t('purchaseOrder_selectVendor')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedVendor.length == 0"
              >Please Select Vendor.</span
            >
          </p>
        </div>

        <div class="col-md-12 mb-3 font-weight-bold">{{ $t("items") }}</div>

        <div
          v-for="(item, vendorIndex) in itemList"
          :key="vendorIndex"
          class="col-md-12 mb-4"
        >
          <div class="row">
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.rm_name"
                    type="text"
                    name="rmname"
                    id="rmname"
                    v-validate="'required'"
                    placeholder="."
                  />
                  <label>{{ $t("item") }} {{ $t("name") }}</label>
                </div>
                <img
                  src="@/assets/img/icons/question.svg"
                  height="20"
                  width="20"
                  class="ml-2"
                  v-b-tooltip.hover
                  :title="'Invoice Item name'"
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('rmname')">{{
                  errors.first("rmname")
                }}</span>
              </p>
            </div>

            <div class="col-md-2">
              <div class="d-flex align-items-center">
                <b-input-group>
                  <b-form-input
                    v-model="item.ii_qty"
                    style="height: 40px;
                    border-top-left-radius: 10px;
                    border-bottom-left-radius: 10px;"
                    type="number"
                    placeholder="Qty"
                  ></b-form-input>

                  <template v-slot:append>
                    <b-dropdown variant="dropdown-curve" class="w-100">
                      <b-dropdown-item
                        v-for="(loop, key) in 500"
                        :key="key"
                        v-on:click="onSelectQuantity(loop, vendorIndex)"
                        >{{ loop }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </template>
                </b-input-group>
                <Tooltip :title="$t('purchaseOrder_Quantity')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && item.ii_qty.length == 0"
                  >Please select or enter quantity.</span
                >
              </p>
            </div>

            <!-- <div class="col-lg-3">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="item.uom_unit.length > 0 ? 'shift-up' : ''">{{ $t('select') }} UOM</label>
                  <b-dropdown :text="item.uom_unit" variant="dropdown-curve" class="w-100">
                    <b-dropdown-item
                      v-for="(measurement , measurementkey) in measurements"
                      :key="measurementkey"
                      v-on:click="onSelectUom(measurement,vendorIndex)"
                    >{{ measurement.uom_unit }}</b-dropdown-item>
                  </b-dropdown>
                </div>
                <Tooltip :title="$t('purchaseOrder_selectUOM')" />
              </div>
              <p class="error_message">
                <span
                  v-if="submitted && item.uom_unit.length == 0"
                >Please Select Unit of Measurement.</span>
              </p>
            </div>-->

            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @input="calcTotal(vendorIndex)"
                    type="number"
                    v-model="item.ii_price"
                    name="netamount"
                    id="netamount"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("netamount") }}</label>
                </div>
                <Tooltip :title="$t('invoic_netamount')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('netamount')">{{
                  errors.first("netamount")
                }}</span>
              </p>
            </div>

            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    @input="calcTotal(vendorIndex)"
                    type="number"
                    v-model="item.ii_tax_amount"
                    name="taxamount"
                    id="taxamount"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("taxamount") }}</label>
                </div>
                <img
                  src="@/assets/img/icons/question.svg"
                  height="20"
                  width="20"
                  class="ml-2"
                  v-b-tooltip.hover
                  :title="'Total Amount'"
                />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('taxamount')">{{
                  errors.first("taxamount")
                }}</span>
              </p>
            </div>

            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="item.ii_total_amount"
                    type="text"
                    name="totalamount"
                    id="totalamount"
                    v-validate="'required|decimal'"
                    placeholder="."
                  />
                  <label>{{ $t("totalamount") }}</label>
                </div>
                <Tooltip :title="$t('totalamount')" />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('totalamount')">{{
                  errors.first("totalamount")
                }}</span>
              </p>
            </div>

            <div
              class="col-lg-1 d-flex align-items-center justify-content-center"
            >
              <button
                v-if="vendorIndex == 0"
                @click="addVendor"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click="removeVendor(vendorIndex)"
                class="btn-transparent"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="35"
                  width="35"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="InvoiceDetails.i_date"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="InvoiceDetails.i_date"
                  name="invociedate"
                  id="invociedate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="
                    InvoiceDetails.i_date &&
                    typeof InvoiceDetails.i_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $t("invoiceorderdate") }}</label
                >
              </div>
            </div>
            <Tooltip :title="$t('invoiceorderdate')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('purchasedate')">{{
              errors.first("purchasedate")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="number"
                v-model="InvoiceDetails.i_total_amount"
                name="finaltotalamount"
                id="finaltotalamount"
                v-validate="'required|decimal'"
              />
              <label>{{ $tc("totalamount", 2) }}</label>
            </div>
            <Tooltip :title="$t('totalamount')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('finaltotalamount')">{{
              errors.first("finaltotalamount")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("invoiceorderlock") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="InvoiceDetails.i_lock"
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <label class="ios-switch ml-2">
              <input
                v-model="InvoiceDetails.i_is_active"
                type="checkbox"
                class="ios-checkbox"
                checked
              />
              <span class="switch-slider"></span>
            </label>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 mt-4 text-center">
          <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">
            {{ $t("update") }}</button
          >&nbsp;
          <router-link to="invoice" class="btn-outline-blue">{{
            $t("cancel")
          }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";

export default {
  data() {
    return {
      removedVendors: [],
      isRoleID: true,
      submitted: false,
      InvoiceDetails: [],
      itemList: [],
      VendorList: [],
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: "",
      RawMaterials: [],
      Vendors: [],
      VendorsCopy: [],
      searchVendor: "",
      measurements: [],
      selectedCinema: "",
      selectedRawMaterial: "",
      selectedVendor: "",
      selectedQuantity: "",
      selectedUom: "",
      po_number: "",
      cinema_id: null
    };
  },
  async beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_id = obj;
    if (true) {
      this.isRoleID = false;
    }
    const { i_number, i_id } = this.$route.query;
    if (i_id && i_number) {
      this.InvoiceDetails.i_number = i_number;
      this.InvoiceDetails.i_id = i_id;
      await this.getOrdersDetails();
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    calcTotal(index) {
      this.itemList[index].ii_total_amount =
        (this.itemList[index].ii_price
          ? parseFloat(this.itemList[index].ii_price)
          : 0) +
        (this.itemList[index].ii_tax_amount
          ? parseFloat(this.itemList[index].ii_tax_amount)
          : 0);
      let total = 0;
      this.itemList.map(x => {
        total += x.ii_total_amount;
      });
      this.InvoiceDetails.i_total_amount = total;
    },
    onSearchVendor: function() {
      if (this.searchVendor && this.searchVendor.length > 0) {
        this.Vendors = this.VendorsCopy.filter(x => {
          if (
            x.v_name.toLowerCase().includes(this.searchVendor.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Vendors = this.VendorsCopy;
      }
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getOrdersDetails: function() {
      let loader = this.$loading.show();

      let payload = {
        i_id: this.InvoiceDetails.i_id
      };
      PosFnbService.GetInvoiceDetails(payload)
        .then(async response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.InvoiceDetails = data.Records[0];
            this.InvoiceDetails.i_lock =
              data.Records[0].i_lock == "Y" ? true : false;
            this.InvoiceDetails.i_date = new Date(this.InvoiceDetails.i_date);
            this.itemList = data.Records.map(x => {
              return x;
            });
            if (
              this.cinema_id &&
              this.cinema_id != this.InvoiceDetails.cinema_id
            ) {
              this.$router.push({ path: "/fnb/invoice" });
            }
            console.log("this.itemList :", this.itemList);
            await this.getVendorsList(this.InvoiceDetails.v_id);
            await this.getCinemasList(this.InvoiceDetails.cinema_id);
            await this.getRawMaterials(data.Records, this.InvoiceDetails.v_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          setTimeout(() => loader.hide(), 1100);
        });
    },
    clearSelectedDate: function() {
      this.InvoiceDetails.po_date = "";
      this.InvoiceDetails.i_date = "";
    },
    getCinemasList: function(cinema_id) {
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: this.cinema_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (x.cine_id == cinema_id) {
                this.onSelectCinema(x);
                // this.selectedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getunitsofmeasurements: function(uom_id, index) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.measurements = data.Records;
            this.measurements.map(x => {
              if (x.uom_id == uom_id) {
                this.VendorList[index].uom_unit = x.uom_unit;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getVendorsList: function(v_id) {
      let payload = {
        tableName: "ms_vendors",
        v_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Vendors = data.Records;
            this.VendorsCopy = data.Records;
            this.Vendors.map(x => {
              if (x.v_id == v_id) {
                this.InvoiceDetails.v_id = v_id;
                this.selectedVendor = x.v_name;
              }
            });
            // this.Vendors.map((x, index) => {
            //   if (x.v_id == v_id) {
            //     this.VendorList.push({
            //       v_name: x.v_name,
            //       v_id: x.v_id,
            //       po_total_amount: po_total_amount,
            //       po_quantity: String(po_quantity),
            //       uom_unit: "",
            //       uom_id: String(uom_id),
            //       po_id: po_id
            //     });
            //   }
            // });
            // this.VendorList.map((x, index) => {
            //   this.getunitsofmeasurements(uom_id, index);
            // });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterials: function(Materials, vendor_id) {
      let loader = this.$loading.show();
      let payload = {
        vendor_id
      };

      PosFnbService.GetVendorRateDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RawMaterials = data.Records;
            this.RawMaterials = this.RawMaterials.map(x => {
              x["singleItemPrice"] = parseFloat(x.vr_rate) / parseInt(x.vr_qty);
              x["singleTaxPrice"] =
                parseFloat(x.vr_tax_amount) / parseInt(x.vr_qty);
              x["singleTotalPrice"] =
                x["singleItemPrice"] + x["singleTaxPrice"];
              return x;
            });
            Materials.map(x => {
              let singleItemPrice =
                parseFloat(x.poi_price) / parseInt(x.poi_qty);
              let singleTaxPrice =
                parseFloat(x.poi_tax_amount) / parseInt(x.poi_qty);
              let array = data.Records.filter(({ rm_id }) => rm_id === x.rm_id);
            });
            // this.RawMaterials.map(x => {});
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          setTimeout(() => loader.hide(), 1100);
        });

      // let payload = {
      //   tableName: "ms_raw_materials",
      //   rm_is_active: "Y"
      // };
      // MasterService.GetActiveList(payload)
      //   .then(response => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       this.RawMaterials = data.Records;
      //     } else {
      //       this.$toasted.show(data.message);
      //     }
      //   })
      //   .catch(this._CatchError)
      //   .finally(async () => {
      //     await this.getOrdersDetails();
      //     setTimeout(() => loader.hide(), 1100);
      //   });
    },
    onSelectCinema: function(params) {
      this.selectedCinema = params.cine_name;
      this.InvoiceDetails.cine_id = params.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
    },

    onSelectVendor: function(params, index) {
      this.selectedVendor = params.v_name;
      this.InvoiceDetails.v_id = params.v_id;
      this.searchVendor = "";
      this.onSearchVendor();
    },

    onSelectQuantity: function(params, index) {
      this.itemList[index]["ii_qty"] = params.toString();
      console.log(
        'this.itemList[index]["poi_qty"] :',
        this.itemList[index]["poi_qty"]
      );
      // this.CalculateSelectedRawMaterial(
      //   this.itemList[index]["ii_qty"],
      //   index
      // );
    },
    // CalculateSelectedRawMaterial: function(params, index) {
    //   console.log("params :", params);
    //   console.log("params :t", typeof params);
    //   console.log("index :", index);
    //   if (String(params).length > 0) {
    //     this.itemList[index]["vendor_rate_id"] =
    //       this.itemList[index].SelectedRawMaterial["vr_id"] || null;
    //     this.itemList[index]["uom_unit"] =
    //       this.itemList[index].SelectedRawMaterial["uom_unit"] || null;
    //     // // uom_id
    //     this.itemList[index]["uom_id"] =
    //       this.itemList[index].SelectedRawMaterial["uom_id"] || null;
    //     this.itemList[index]["poi_is_active"] = true;
    //     this.itemList[index]["poi_price"] =
    //       parseInt(params) *
    //       this.itemList[index].SelectedRawMaterial["singleItemPrice"];
    //     this.itemList[index]["poi_tax_amount"] =
    //       parseInt(params) *
    //       this.itemList[index].SelectedRawMaterial["singleTaxPrice"];

    //     this.itemList[index]["poi_total_amount"] =
    //       parseInt(params) *
    //       this.itemList[index].SelectedRawMaterial["singleTotalPrice"];
    //     this.InvoiceDetails.po_total_amount = 0;
    //     this.itemList.map(x => {
    //       this.InvoiceDetails.po_total_amount += parseFloat(x.poi_total_amount);
    //     });
    //   }
    // },

    // onSelectUom: function(params, index) {
    //   this.itemList[index].uom_unit = params.uom_unit;
    //   this.itemList[index].uom_id = params.uom_id;
    // },
    addVendor: function() {
      this.itemList.push({
        rm_name: "",
        rm_id: "",
        poi_price: "",
        poi_tax_amount: "",
        poi_total_amount: "",
        po_quantity: "",
        poi_qty: "",
        uom_unit: "",
        uom_id: "",
        po_total_amount: "",
        SelectedRawMaterial: null
      });
    },
    removeVendor: function(index) {
      if (this.itemList[index].ii_id) {
        this.removedVendors.push(this.itemList[index]);
      }
      this.itemList.splice(index, 1);
      let total = 0;
      this.itemList.map(x => {
        total += x.ii_total_amount;
      });
      this.InvoiceDetails.i_total_amount = total;
      console.log("this.removedVendors :>> ", this.removedVendors);
    },
    QuantityValidation: function() {
      let count = 0;

      this.itemList.map(x => {
        if (x.ii_qty && String(x.ii_qty).length == 0) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (this.QuantityValidation()) {
          return;
        }
        if (valid) {
          let loader = this.$loading.show();

          let payload = {
            ...this.InvoiceDetails,
            purchaseOrder: this.itemList,
            removedVendors: this.removedVendors
          };
          PosFnbService.UpdateInvoice(payload)
            .then(response => {
              loader.hide();

              const { data } = response;
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/fnb/invoice"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/editInvoice.vue